// extracted by mini-css-extract-plugin
module.exports = {"link":"gehhN","PlasticButton":"_3pBgH","plasticButton":"_3pBgH","label":"_3DX1s","mainColor":"xv6UZ","pose":"cno8a","topper":"_JPAs","oval":"_3Ifwk","bord":"_3eh3V"};